// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/widgets/web/7892/js/" + chunkId + ".chunk.js";
};